module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-position-relative"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "a-loader--typeahead"
  }) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "typeaheadField",
      "label": _vm.label
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:typeaheadField.required",
      value: ({
        type: 'text',
        rules: 'name'
      }),
      expression: "{type:'text', rules:'name'}",
      arg: "typeaheadField",
      modifiers: {
        "required": true
      }
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "typeaheadField",
      "maxlength": "100",
      "required": "",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.down.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.up.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.hit.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.reset.apply(null, arguments)
      }],
      "blur": _vm.reset,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }, _vm.update]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('typeaheadField')
    }
  }, [_vm._v("\n            " + _vm._s(_vm.errorMessage) + "\n        ")])], 1), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasItems && _vm.inFocus),
      expression: "hasItems && inFocus"
    }]
  }, _vm._l((_vm.items), function(item, $item) {
    return _c('li', {
      class: _vm.activeClass($item),
      on: {
        "mousedown": _vm.hit,
        "mousemove": function($event) {
          return _vm.setActive($item)
        }
      }
    }, [_c('span', {
      staticClass: "name",
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "screen-name",
      domProps: {
        "textContent": _vm._s(item.screen_name)
      }
    })])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-54317516!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Typeahead.vue
// module id = 1694
// module chunks = 0